import React, { useEffect, useRef, useState } from "react";

// ASSETS
import { ReactComponent as SearchIconYellow } from "assets/svg/SearchIconYellow.svg";

// STYLES
import {
  LineContainer,
  PositionContainer,
  Container,
  SearchContainer,
  Title,
  FilterContainer,
  SearchInput,
  RedButtonWrapper,
  ModalContent,
} from "./EventsGirdleStyled";

// LIBRARIES
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./EventsGirdleModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { UsageType } from "components/Atoms/SelectInputFilter/SelectInputFilterModel";
import { CalendarType } from "components/Atoms/CalendarFilter/CalendarFilterModel";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import SelectInputFilter from "components/Atoms/SelectInputFilter/SelectInputFilter";
import CalendarFilter from "components/Atoms/CalendarFilter/CalendarFilter";

const EventsGirdle = (props: IProps) => {
  // PROPERTIES
  const {
    searchTerm,
    setSearchTerm,
    checkedState,
    setCheckedState,
    month,
    year,
    setMonth,
    setYear,
    fetchFilteredEvents = () => {},
  } = props;

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const isTablet = useMediaQuery({ maxWidth: 1400 });
  const menuRef = useRef(null);

  // STATE CONSTANTS
  const [isOpen, setIsOpen] = useState<boolean>(false);

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen]);

  // EVENT HANDLERS
  const handleApplyFilters = () => {
    //add logic after integration
    setIsOpen(false);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <PositionContainer ref={menuRef}>
      {isTablet ? (
        <Container>
          <LineContainer onClick={() => setIsOpen((prevState) => !prevState)} />
          <Title>
            <CustomText
              text={t("components.eventsGirdle.title")}
              type={TextType.H5bold}
              color={COLORS.Background}
            />
          </Title>
          {isOpen && (
            <ModalContent onClick={stopPropagation}>
              <SearchContainer>
                <SearchIconYellow />
                <SearchInput
                  type="text"
                  placeholder={t("components.eventsGirdle.searchPlaceholder")}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <ButtonAtom
                  text={t("components.eventsGirdle.search")}
                  type={ButtonType.BlackButton}
                  onClick={fetchFilteredEvents}
                />
              </SearchContainer>
              <SelectInputFilter
                type={UsageType.girdle}
                checkedState={checkedState}
                setCheckedState={setCheckedState}
              />
              <CalendarFilter
                type={CalendarType.girdle}
                month={month}
                year={year}
                setMonth={setMonth}
                setYear={setYear}
              />
              <RedButtonWrapper>
                <ButtonAtom
                  text={t("components.eventsGirdle.apply")}
                  type={ButtonType.RedButton}
                  onClick={fetchFilteredEvents}
                />
              </RedButtonWrapper>
            </ModalContent>
          )}
        </Container>
      ) : (
        <Container>
          <FilterContainer>
            <Title>
              <CustomText
                text={t("components.eventsGirdle.title")}
                type={TextType.H5bold}
                color={COLORS.Background}
              />
            </Title>
            <SearchContainer>
              <SearchIconYellow />
              <SearchInput
                type="text"
                placeholder={t("components.eventsGirdle.searchPlaceholder")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <ButtonAtom
                text={t("components.eventsGirdle.search")}
                type={ButtonType.BlackButton}
                onClick={fetchFilteredEvents}
              />
            </SearchContainer>
            <SelectInputFilter
              type={UsageType.girdle}
              checkedState={checkedState}
              setCheckedState={setCheckedState}
            />
            <CalendarFilter
              type={CalendarType.girdle}
              month={month}
              year={year}
              setMonth={setMonth}
              setYear={setYear}
            />
          </FilterContainer>
          <RedButtonWrapper>
            <ButtonAtom
              text={t("components.eventsGirdle.apply")}
              type={ButtonType.RedButton}
              onClick={fetchFilteredEvents}
            />
          </RedButtonWrapper>
        </Container>
      )}
    </PositionContainer>
  );
};

export default EventsGirdle;
